baseApp.directive('memberOfGroups', function() {
    return {
        restrict: 'E',
    	replace: false,
        templateUrl: '/public/directives/memberOfGroups.html',
        scope: {
            url: "@",
            modified: "="
        },
        controller: ["$scope", function ($scope) {
            $scope.groupsConfig = {
            	dataURL: function () {
            		return $scope.url;
            	},
            	method: 'GET',
            	showTable: false,
            	pageSize: -1,
            	fields: [
                    { label: 'Name', path: 'name', template: "{{item.name}}" },
                    { label: 'Description', path: 'description', template: "{{item.description}}" }
            	],
            	type: 'Group',
            	hideCheckboxes: true,
            	editTable: false,
            	processData: function (items) {
            		$scope.groupsConfig.origItems = angular.copy(items);
            	},
            	defer: true,
            	noSearch: true,
            	clientSideSort: true
            };
        }]
    }
});